/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Request_Modal_SubtitleInputs */

const en_cancel_request_modal_subtitle = /** @type {(inputs: Cancel_Request_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service desk will review your request — the ticket isn't cancelled automatically.`)
};

const ja_cancel_request_modal_subtitle = /** @type {(inputs: Cancel_Request_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスデスクが要求を確認します — チケットは自動でキャンセルされません。`)
};

const fr_cancel_request_modal_subtitle = /** @type {(inputs: Cancel_Request_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le service desk examinera votre demande — le ticket n'est pas annulé automatiquement.`)
};

const de_cancel_request_modal_subtitle = /** @type {(inputs: Cancel_Request_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Service Desk prüft Ihre Anfrage — das Ticket wird nicht automatisch storniert.`)
};

/**
* | output |
* | --- |
* | "Service desk will review your request — the ticket isn't cancelled automatically." |
*
* @param {Cancel_Request_Modal_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cancel_request_modal_subtitle = /** @type {((inputs?: Cancel_Request_Modal_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Request_Modal_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancel_request_modal_subtitle(inputs)
	if (locale === "ja") return ja_cancel_request_modal_subtitle(inputs)
	if (locale === "fr") return fr_cancel_request_modal_subtitle(inputs)
	return de_cancel_request_modal_subtitle(inputs)
});